<template>
  <b-container fluid>
    <b-row>

      <!-- <b-col cols="12" class="bg-title">
        <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-none d-lg-block">
            <font> Trámites</font>
        </h5>
        <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-block d-lg-none">
          <b-icon @click="isShowSidePanel=!isShowSidePanel; " icon="list" shift-v="-2" font-scale="1.3"/>
            <font> Trámites</font> </h5>        
            
      </b-col> -->
    

      <b-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="catalogFormas.tiposFormas!= null && catalogFormas.tiposFormas.length>0">
        <b-row align-h="center">
          <b-col cols="11" sm="11" md="11" lg="11" xl="11" class="card-form-primary mt-5">

            <b-row align-h="between" @click="expandForm(!isFormCollapse)" style="cursor:pointer;">
              <b-col class="mt-3 mb-2">
              <h5 style="color: #312bb5; text-transform:capitalize;"><b-icon icon="files"/> Búsqueda de Trámites</h5>
              <!-- <h6 style="color: gray; text-transform:capitalize;">{{formasFormModel.inSelectTipoBusqueda.model.toLowerCase()}}</h6> -->
              </b-col>
              <b-col class="mt-3" cols="2" md="1" v-if="isFormCollapse">
                  <b-icon style="color: #312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-down" />
              </b-col>
              <b-col class="mt-3" cols="2" md="1" v-if="!isFormCollapse">
                  <b-icon style="color: #312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-up"/>
              </b-col>
            </b-row>

            <b-row v-if="!isFormCollapse">
              <b-col>
                <b-row  class="mt-3"> 
                  <b-col cols="12" >
                    <h6 style="color: gray; text-transform:capitalize;">Buscar por</h6>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group>
                      <b-form-select size="sm" v-model="formasFormModel.inSelectTipoForma.model" :options="catalogFormas.tiposFormas" @change="configTipoFormaBusqueda()"/>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" lg="3" v-if="formasFormModel.inSelectTipoForma.model!=null && formasFormModel.inSelectTipoForma.model!='' && formasFormModel.inSelectTipoForma.model!='EXPEDIENTES'">
                    <b-form-checkbox v-model="isBusquedaAvanzada" @change="configTipoFormaBusqueda()"><label>Búsqueda Avanzada</label></b-form-checkbox>
                  </b-col>

                </b-row>

                <b-row v-if="formasFormModel.inSelectTipoForma.model!=null && formasFormModel.inSelectTipoForma.model!='' && formasFormModel.inSelectTipoForma.model!='EXPEDIENTES'">
                  <b-col cols="12" md="3" lg="2">
                    <b-form-group v-if="!isBusquedaAvanzada" label="Serie:">
                      <b-form-input size="sm" :state="!$v.formasFormModel.inTxtSerie.$invalid" type="text" v-model.trim="$v.formasFormModel.inTxtSerie.model.$model" @change="cleanResults"></b-form-input>
                      <div class="error" v-if="!$v.formasFormModel.inTxtSerie.model.required">Este campo es obligatorio.</div>
                      <div class="error" v-if="!$v.formasFormModel.inTxtSerie.model.alpha">Serie incorrecta</div>
                      <div class="error" v-if="!$v.formasFormModel.inTxtSerie.model.minLength">Serie incorrecta.</div>
                      <div class="error" v-if="!$v.formasFormModel.inTxtSerie.model.maxLength">Serie incorrecta.</div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="3" lg="2">
                    <b-form-group v-if="!isBusquedaAvanzada" label="Folio:">
                      <b-form-input size="sm" :state="!$v.formasFormModel.inNumFolio.$invalid" type="number" v-model.trim="$v.formasFormModel.inNumFolio.model.$model" @change="cleanResults"></b-form-input>
                      <div class="error" v-if="!$v.formasFormModel.inNumFolio.model.required">Este campo es obligatorio.</div>
                      <div class="error" v-if="!$v.formasFormModel.inNumFolio.model.between">Folio fue del rango.</div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="formasFormModel.inSelectTipoForma.model=='EXPEDIENTES'" class="mb-3">
                  <b-col cols="12"  lg="8">
                    <label>Tipo de expediente</label>
                    <b-form-select size="sm" v-model="idTramiteInfo" :options="catalogFormas.tramitesInfo"  value-field="idServiceInfo" text-field="nombreServiceInfo"></b-form-select>
                  </b-col>
                  <b-col cols="12"  lg="4">
                    <label >Estado del expediente</label>
                    <b-form-select size="sm" v-model="estadoTramiteInfo" :options="estadosTramitesInfo"></b-form-select>
                  </b-col>
                </b-row>


                <b-row>
                  <b-col cols="12" lg="6">  
                    <b-alert variant="danger" :show="msgErrorFormasSimple != ''">
                        {{msgErrorFormasSimple}}
                    </b-alert>
                  </b-col>
                </b-row>
                <!-- BUSQUEDA SIMPLE -->
                <b-row v-if="formasFormModel.inSelectTipoForma.model!=null && formasFormModel.inSelectTipoForma.model!='' && formasFormModel.inSelectTipoForma.model!='EXPEDIENTES'">
                  <b-col cols="12" md="3" lg="2" class="mb-3">
                    <b-button v-if="!isBusquedaAvanzada" @click="getFormasValoradas" block variant="success" size="sm">
                      <b-spinner variant="success" v-if="isConsultando"></b-spinner>
                      <strong v-if="isConsultando">&nbsp;&nbsp;Buscando . . .</strong>
                      <b-icon icon="search" v-if="!isConsultando"/>
                      <strong v-if="!isConsultando"> Buscar</strong>
                    </b-button>
                  </b-col>
                </b-row>
                <!-- BUSQUEDA AVANZADA -->
                <b-row v-if="formasFormModel.inSelectTipoForma.model!=null && formasFormModel.inSelectTipoForma.model!='' &&  formasFormModel.inSelectTipoForma.model!='EXPEDIENTES'">
                  <b-col cols="12" lg="12">
                    <AvanzadaFormasForm v-if="isBusquedaAvanzada"/>
                  </b-col>
                </b-row>
                <!-- BUSQUEDA TRAMITES -->
                <b-row v-if="formasFormModel.inSelectTipoForma.model!=null && formasFormModel.inSelectTipoForma.model!='' && formasFormModel.inSelectTipoForma.model=='EXPEDIENTES'">
                  <b-col cols="12" md="3" lg="2" class="mb-3">
                    <b-button @click="getFormasValoradas" block variant="success" size="sm">
                      <b-spinner variant="success" v-if="isConsultando"></b-spinner>
                      <strong v-if="isConsultando">&nbsp;&nbsp;Buscando . . .</strong>
                      <b-icon icon="search" v-if="!isConsultando"/>
                      <strong v-if="!isConsultando"> Buscar</strong>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col  cols="11" sm="11" md="11" lg="11" xl="11" class="card-form-blue mt-5">
            <b-row>
              <b-col>
                <FormasTable/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-col>
      
    </b-row>
  </b-container>
</template>

<script>
import FormasTable from '@/components/formas-valoradas/FormasTable.vue'
import AvanzadaFormasForm from '@/components/formas-valoradas/AvanzadaFormasForm.vue'
import { minLength, alpha, maxLength, between, requiredIf} from 'vuelidate/lib/validators'
import axios from 'axios'
import { server, checkAuth, getPostConfig, handledError } from '@/axios-tools'
import { mapState} from 'vuex'


export default {
  data(){
    return {
      isShowSidePanel:true,
      isBusquedaAvanzada:false,
      idTramiteInfo : null,
      estadoTramiteInfo: null,
      estadosTramitesInfo:["INICIADO","POR REVISAR","PENDIENTE PAGO","PAGADO","POR ENTREGAR","CONCLUIDO","CANCELADO"]
    }
  },
  components: {
    AvanzadaFormasForm,
    FormasTable
  },
  computed: {
    ...mapState ({
    isConsultando: state => state.formas.isConsultando,
    formasFormModel: state => state.formas.formasFormModel,
    isFormCollapse: state => state.formas.isFormCollapse,
    token: state => state.login.token,
    msgErrorFormasSimple: state => state.formas.msgErrorFormasSimple,
    catalogFormas: state => state.formas.catalogFormas,
    })
  },
  mounted(){
    if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
        
      }
      window.scrollTo(0, 0);
  },
  methods:{
    configCurrentDates(){
      this.$store.commit("configCurrentDates");
    },
    cleanResults (){
      this.$store.commit("updateFormas", []);
      this.$store.commit("updateFormasClasificado", null);
      this.$store.commit("updateMsgErrorFormasSimple", "");
      this.$store.commit("updateMsgFormasCancelar", '');
    },
    getFormasValoradas: function () {
      if(!this.isConsultando & !this.$v.$invalid & checkAuth(this.$router, this.$store)){
        this.$store.commit("updateIsConsultando", true);
        this.cleanResults();
        if(this.formasFormModel.inSelectTipoForma.model == "RECIBOS DEL SISTEMA"){
          axios(
            getPostConfig(server.recibos, this.formasFormModel, this.token)
            ).then(res => {
              this.$store.commit("updateFormas", res.data[0]);
              this.$store.commit("updateIsFormCollapse", true);
              //this.$store.commit("updateTotalRecibosMonto", res.data[1]);
              this.$store.commit("updateIsConsultando", false);
              if(res.data[1]!=null){
                this.$store.commit("updateFormasClasificado", res.data[1]);
              }
          }).catch(err => {
              this.$store.commit("updateIsConsultando", false);
              handledError(err, server.ordenes, this.$router, this.$store);
          })
        }
        else if(this.formasFormModel.inSelectTipoForma.model == "ÓRDENES DE PAGO"){
          axios(
            getPostConfig(server.ordenes, this.formasFormModel, this.token)
            ).then(res => {
              this.$store.commit("updateFormas", res.data);
              this.$store.commit("updateIsFormCollapse", true);
              this.$store.commit("updateIsConsultando", false);
          }).catch(err => {
              this.$store.commit("updateIsConsultando", false);
              handledError(err, server.ordenes, this.$router, this.$store);
          })
        }
        else if(this.formasFormModel.inSelectTipoForma.model == "EXPEDIENTES"){
          axios(
            getPostConfig(server.tramites, {status:this.estadoTramiteInfo, idServiceInfo:this.idTramiteInfo}, this.token)
            ).then(res => {
              this.$store.commit("updateFormas", res.data);
              this.$store.commit("updateIsFormCollapse", true);
              this.$store.commit("updateIsConsultando", false);
          }).catch(err => {
              this.$store.commit("updateIsConsultando", false);
              handledError(err, server.tramites, this.$router, this.$store);
          })
        }
      }
    },
    expandForm(is){
      this.$store.commit("updateIsFormCollapse", is);
    },
    configTipoFormaBusqueda(){
      //this.cleanResults();
      //this.configCurrentDates();
      this.formasFormModel.inSelectTipoForma.model
      if(this.formasFormModel.inSelectTipoForma.model == 'RECIBOS DEL SISTEMA'){
        if(this.isBusquedaAvanzada){
          this.formasFormModel.inSelectTipoBusqueda.model = 'BÚSQUEDA AVANZADA';
        }else{
          this.formasFormModel.inSelectTipoBusqueda.model = 'POR FOLIO DE RECIBO';
        }
      }else if(this.formasFormModel.inSelectTipoForma.model == 'ÓRDENES DE PAGO'){
        if(this.isBusquedaAvanzada){
          this.formasFormModel.inSelectTipoBusqueda.model = 'BÚSQUEDA AVANZADA';
        }else{
          this.formasFormModel.inSelectTipoBusqueda.model = 'POR FOLIO DE ORDEN';
        }
      }else if(this.formasFormModel.inSelectTipoForma.model == 'EXPEDIENTES'){
        if(this.isBusquedaAvanzada){
          this.formasFormModel.inSelectTipoBusqueda.model = '';
        }else{
          this.formasFormModel.inSelectTipoBusqueda.model = '';
        }
      }else{
        this.formasFormModel.inSelectTipoBusqueda.model = '';
      }
    }
  },
  validations: {
    formasFormModel:{
      inTxtSerie: {
        model:{
          required: requiredIf(function() {return !this.isBusquedaAvanzada && this.formasFormModel.inSelectTipoForma.model != "EXPEDIENTES"}),
                    alpha,
                    minLength: minLength(2),
                    maxLength: maxLength(3)
        }
      },
      inNumFolio: {
        model:{
          required: requiredIf(function() {return !this.isBusquedaAvanzada && this.formasFormModel.inSelectTipoForma.model != "EXPEDIENTES"}),
                    between: between(0, 999999)
        }
      }
    }
  }
}
</script>